// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__29Is4","selected":"Chip_selected__ih3q0"};